import $ from 'jquery';
import ko from '@tko/build.knockout';
import Signals from 'signals';
import templateMarkup from 'raw-loader!./common-widget.html';
import 'components-bootstrap';

function CommonWidget(params) {
    var self = this;
    self.widgetName = params.widgetName;
    self.widgetParams = params.widgetParams;
    self.viewLevelOptions = params.viewLevelOptions;
    self.dashboardsAndTabsList = params.dashboardsAndTabsList;
    self.selectedTab = params.selectedTab;
    self.viewId = params.viewId;

    self.id = self.widgetParams.observableOptions().id;
    self.subscriptions = [];
    self.showLoadingIcon = ko.observable(true);
    self.showLongLoadMessage = ko.observable(false);
    self.showOutdatedMessage = ko.observable(false);
    self.allowExport = ko.pureComputed(function() {
        return !self.showLoadingIcon();
    });
    self.optionsmodalopen = ko.observable(false);
    self.widgetSignals = ko.observable({
        optionsPanelToggle: new Signals.Signal(),
        optionsPanelOpen: new Signals.Signal(),
        optionsPanelClose: new Signals.Signal(),
        optionsPanelApply: new Signals.Signal(),
        optionsSignal: params.widgetParams.optionsSignal,
        dataLoaded: new Signals.Signal(),
        dataRequested: new Signals.Signal(),
        longDataWait: new Signals.Signal(),
        titleSignal: params.widgetParams.titleSignal,
        clonePanel: new Signals.Signal(),
        movePanel: new Signals.Signal(),
        copyPanel: new Signals.Signal(),
        copyPanelAdvanced: new Signals.Signal()
    });

    self.widgetParams.widgetSignals = self.widgetSignals;

    self.widgetSignals().optionsPanelToggle.add(self.ToggleOptionsPanelCallback, self);
    self.widgetSignals().optionsPanelOpen.add(self.OpenOptionsPanelCallback, self);
    self.widgetSignals().optionsPanelClose.add(self.removeOptionsPanel, self);
    self.widgetSignals().optionsPanelApply.add(self.applyOptionsPanel, self);
    self.widgetSignals().dataLoaded.add(self.DataLoadedCallback, self);
    self.widgetSignals().dataRequested.add(self.DataRequestedCallback, self);
    self.widgetSignals().longDataWait.add(self.longDataWaitCallback, self);
    self.widgetSignals().clonePanel.add(self.clonePanelCallback, self);
    self.widgetSignals().movePanel.add(self.movePanelCallback, self);
    self.widgetSignals().copyPanel.add(self.copyPanelCallback, self);
    self.widgetSignals().copyPanelAdvanced.add(self.copyPanelAdvancedCallback, self);
}

CommonWidget.prototype.DataLoadedCallback = function () {
    var self = this;
    if (self.foundOutdatedColumns()) {
      self.showLoadingIcon(true);
      self.showLongLoadMessage(false);
      self.showOutdatedMessage(true);
    } else {
      self.showLoadingIcon(false);
      self.showLongLoadMessage(false);
    }

};

CommonWidget.prototype.DataRequestedCallback = function () {
    var self = this;
    self.showLoadingIcon(true);
};

CommonWidget.prototype.longDataWaitCallback = function()  {
    var self = this;
    self.showLongLoadMessage(true);
};

CommonWidget.prototype.ToggleOptionsPanelCallback = function () {
    var self = this;
    if (!self.optionsmodalopen()) {
        self.widgetSignals().optionsPanelOpen.dispatch();
    } else {
        self.widgetSignals().optionsPanelClose.dispatch();
    }
};

CommonWidget.prototype.OpenOptionsPanelCallback = function() {
    var self = this;
    var modalEl = $('#optionsModal' + self.id);
    $('body').prepend(modalEl);
    modalEl.modal('show');
};

CommonWidget.prototype.applyOptionsPanel = function(options) {
    var self = this;
    var panel = $('#optionsModal' + self.id);

    if (self.widgetParams.optionsSignal) {
      self.widgetParams.optionsSignal.dispatch(self.widgetParams.observableOptions());
    }

    if (panel) {
        panel.modal("hide");
        $('#optionsComp' + self.id).prepend(panel);
    }
};

CommonWidget.prototype.removeOptionsPanel = function() {
    var self = this;
    var panel = $('#optionsModal' + self.id);

    if (panel) {
        panel.modal("hide");
        $('#optionsComp' + self.id).prepend(panel);
    }
};

CommonWidget.prototype.foundOutdatedColumns = function() {
  const self = this;
  const metadata = self.widgetParams.observableData().metadata;
  const columns = self.widgetParams.observableOptions().displayDetail || self.widgetParams.observableOptions().selectedMetricColumnNames;
  // if no metadata we can't know if columns are valid so return false
  if (!metadata) {
    return false;
  }
  let invalidColumnFound = false;
  columns.forEach((column) => {
    let match = metadata.Table.find(columnObject => columnObject.columnKey === column);
    if (!match) {
      invalidColumnFound = true;
    }
  });
  return invalidColumnFound;
}

CommonWidget.prototype.clonePanelCallback = function() {
  let self = this;
  if (self.widgetParams.clonePanelSignal) {
    self.widgetParams.clonePanelSignal.dispatch(self.widgetParams.panelTemplate, self.widgetParams.observableOptions());
  }
}

CommonWidget.prototype.movePanelCallback = function(viewId, tab, panelId) {
  let self = this;
  if (self.widgetParams.movePanelSignal) {
    self.widgetParams.movePanelSignal.dispatch(viewId, tab, panelId, self.widgetParams.panelTemplate, self.widgetParams.observableOptions());
  }
}

CommonWidget.prototype.copyPanelCallback = function() {
  let self = this;
  if (self.widgetParams.copyPanelSignal) {
    self.widgetParams.copyPanelSignal.dispatch();
  }
}

CommonWidget.prototype.copyPanelAdvancedCallback = function() {
  let self = this;
  if (self.widgetParams.copyPanelAdvancedSignal) {
    self.widgetParams.copyPanelAdvancedSignal.dispatch();
  }
}

// This runs when the component is torn down. Put here any logic necessary to clean up,
// for example cancelling setTimeouts or disposing Knockout subscriptions/computeds.
CommonWidget.prototype.dispose = function() {
    var self = this;

    self.subscriptions.forEach(function(sub) {
        sub.dispose();
    });

    if ($('#optionsModal' + self.id)[0]) {
        var optionsVm = ko.dataFor($('#optionsModal' + self.id)[0]);

        if (optionsVm) {
            optionsVm.dispose();
        }
        $('#optionsModal' + self.id).remove();
    }
};

export default { viewModel: CommonWidget, template: templateMarkup };
